import { createFileRoute } from "@tanstack/react-router";
import { type HarvestOperationTemplateRevisionId } from "@brewbase/db/types";
import { trpc } from "@/hooks/trpc";
import { TemplateBlockEditor } from "@/features/template-block-editor/template-block-editor";
import { useOperationEditorConfig } from "@/features/harvest-operation-template/template-block-editor-adapter";

export const Route = createFileRoute(
  "/harvests/operation-templates/$template_id/attributes",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { template_id } = Route.useParams();
  const { data: draft } =
    trpc.harvest.operationTemplates.revisionGetDraftForTemplate.useQuery(
      template_id,
    );
  if (!draft) return null;
  return <OperationAttributesEditor templateId={draft.id} />;
}

function OperationAttributesEditor({
  templateId,
}: {
  templateId: HarvestOperationTemplateRevisionId;
}) {
  const config = useOperationEditorConfig(templateId);
  return <TemplateBlockEditor config={config} />;
}
